import { injectBaseConstantMethods } from "./BaseConstants"

const MoldColorConfiguration = {
   Green: "Green",
   Blue: "Blue",
   Orange: "Orange",
   Yellow: "Yellow",
   White: "White",
   Black: "Black",
   NO_COLOR: "NO_COLOR",
   // Red: "Red",
   // Grey: "Grey",
   // Purple: "Purple",
}

const displayTextKeys = {
   [MoldColorConfiguration.Green]: "Green",
   [MoldColorConfiguration.Blue]: "Blue",
   [MoldColorConfiguration.Red]: "Red",
   [MoldColorConfiguration.Yellow]: "Yellow",
   [MoldColorConfiguration.Orange]: "Orange",
   [MoldColorConfiguration.White]: "White",
   [MoldColorConfiguration.Black]: "Black",
   [MoldColorConfiguration.Grey]: "Grey",
   [MoldColorConfiguration.Purple]: "Purple",
   [MoldColorConfiguration.NO_COLOR]: "No Color",
}

const labelClass = {
   [MoldColorConfiguration.Green]: "mould-color-green",
   [MoldColorConfiguration.Blue]: "mould-color-blue",
   [MoldColorConfiguration.Red]: "mould-color-blue",
   [MoldColorConfiguration.Yellow]: "mould-color-yellow",
   [MoldColorConfiguration.Orange]: "mould-color-orange",
   [MoldColorConfiguration.White]: "mould-color-white",
   [MoldColorConfiguration.Black]: "mould-color-black",
   [MoldColorConfiguration.Grey]: "mould-color-grey",
   [MoldColorConfiguration.Purple]: "mould-color-purple",
   [MoldColorConfiguration.NO_COLOR]: "mould-color-no_color",
}

export default injectBaseConstantMethods(
   MoldColorConfiguration,
   displayTextKeys,
   labelClass
)
